import script from "./EmployeesView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesView.vue?vue&type=script&setup=true&lang=js"

import "./EmployeesView.vue?vue&type=style&index=0&id=dac7bf00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac7bf00"]])

export default __exports__